// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
    getDatabase,
    ref,
    onValue,
    update,
    set,
    onDisconnect,
    serverTimestamp,
    remove // Ensure all functions intended for export are imported
} from "firebase/database";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDgBtC_JxzpbmLiEmAVDshMAWz-Cltce_s",
  authDomain: "debate-app-dc515.firebaseapp.com",
  projectId: "debate-app-dc515",
  storageBucket: "debate-app-dc515.firebasestorage.app",
  messagingSenderId: "157591366307",
  appId: "1:157591366307:web:e8efb586ef0db15491ed16",
  measurementId: "G-9QCZ3NR004"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
const analytics = getAnalytics(app);

// --- ADDED: Export database functions for convenience ---
export { ref, onValue, update, set, onDisconnect, serverTimestamp, remove }; // Added remove